import type { ButtonHTMLAttributes, PropsWithChildren } from "react";
import clsx from "clsx";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost" | "danger";
}

const styles: Record<NonNullable<ButtonProps["variant"]>, string> = {
  primary:
    "bg-app-primary text-[color:var(--color-on-primary)] shadow-premium hover:opacity-95 focus-visible:ring-2 focus-visible:ring-[var(--color-primary)] focus-visible:ring-offset-2",
  secondary:
    "bg-app-surface border border-app text-app-foreground hover:bg-app-surface-muted",
  ghost: "text-app-primary hover:bg-app-surface-muted",
  danger: "bg-red-500 text-white hover:bg-red-600"
};

export const Button = ({
  children,
  className,
  variant = "primary",
  type = "button",
  ...props
}: PropsWithChildren<ButtonProps>) => (
  <button
    type={type}
    className={clsx(
      "inline-flex items-center justify-center rounded-xl px-4 py-2.5 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-60",
      styles[variant],
      className
    )}
    {...props}
  >
    {children}
  </button>
);
